import type { components } from '@/generated/events.js';
import { authService } from '@/services/auth.js';

type SSETokenResp = components['schemas']['SSETokenResp'];
export type NotificationRequest = components['schemas']['NotificationRequest'];
export type NotificationResponse = components['schemas']['NotificationResponse'];

class EventsClient {
    private async _authHeaders(): Promise<Record<string, string>> {
        await authService.ensureValidToken();
        return { Authorization: `Bearer ${authService.getToken()!}` };
    }

    async issueToken(): Promise<SSETokenResp> {
        const res = await fetch('/api/events/v1/sse-token', {
            headers: await this._authHeaders()
        });
        if (!res.ok) throw new Error(`Failed to issue SSE token: ${res.status}`);
        return res.json();
    }

    eventStreamUrl(token: string): string {
        return `/api/events/v1/events?token=${encodeURIComponent(token)}`;
    }

    async sendNotifications(req: NotificationRequest): Promise<NotificationResponse> {
        const res = await fetch('/api/events/v1/notifications', {
            method: 'POST',
            headers: { ...await this._authHeaders(), 'Content-Type': 'application/json' },
            body: JSON.stringify(req)
        });
        if (!res.ok) throw new Error(`Failed to send notifications: ${res.status}`);
        return res.json();
    }
}

export const eventsClient = new EventsClient();